// Try to avoid using the global scope, but if you have to use it, put variables/functions here.

window.notifications = [];
